import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { expandConfigView, installSchema } from '../actions/app';
import SsoForm from '../components/sso-form';
import { ADOBE } from '../constants';
import { styles } from '../style';
import { IApp } from '../types/app';

class Salesforce extends React.Component<IApp | any, any> {
  public render() {
    const { classes } = this.props;
    return (
      <div style={this.props.style}>
        <Tooltip title='When enabled, this indicates the schema has been installed for this integration'>
          <FormControlLabel
            label='Schema Installed'
            control={
              <Switch checked={this.props.schemaInstalled} value='installed' onClick={this.toggleInstallSchema} />
            }
          />
        </Tooltip>
        <ExpansionPanel expanded={this.props.configuredExpanded} onChange={this.togleExpandConfig} disabled={!this.props.schemaInstalled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Token Configuration</Typography>
            <Typography className={classes.secondaryHeading}>Configuration for connection between Flybits and Adobe AM</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <SsoForm onSubmit={this.integrate}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div >
    );
  }
  private toggleInstallSchema = () => this.props.dispatch(installSchema(!this.props.schemaInstalled))
  private togleExpandConfig = () => this.props.dispatch(expandConfigView(!this.props.configuredExpanded))
  private integrate = () => {
    window.location.href = ADOBE.ADOBE_HOST + '/oauth/authorize?response_type=code&client_id=' + ADOBE.ADOBE_CLIENT_ID + '&redirect_uri=' + encodeURI('https://uidemo.flybits.com');
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withStyles(styles)(withRouter(connect(
  mapStateToProps,
)(Salesforce)));



// WEBPACK FOOTER //
// ./src/sub-projects/adobe/containers/content.tsx